<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết nhật ký đồng bộ danh mục</strong>
                    </div>
                    <div>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(masterDataSync.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tài khoản đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ masterDataSync.syncUserName }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Ngày đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ masterDataSync.syncDate | formatTime }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Thời gian thực hiện:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ masterDataSync.elapsedTime }} ms</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Loại đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getMasterDataSyncTypeName(masterDataSync.masterDataType) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getStatusName(masterDataSync.status ? 1 : 0) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Mã quá trình đồng bộ (UUID):"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ masterDataSync.syncProcessId }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="form-group row" v-if="masterDataSync.errorMessage">
                            <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Thông tin lỗi:</label>
                            <label class="text-danger col-8 col-md-10" style="padding-left: 7px">
                                {{ masterDataSync.errorMessage }}
                            </label>
                        </div>
                        <div class="form-group row">
                            <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Dữ liệu gốc:</label>
                            <div class="col-8 col-md-10">
                                <json-viewer :data="masterDataSync.rawData"></json-viewer>
                            </div>
                        </div>
                    </div>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :dataUrl="`logging/master-data-sync-logs/${logId}/data`"
                            gridName="Danh sách dữ liệu được đồng bộ"
                            ref="masterDataSyncLogDataTable" v-if="logId">
                        <template v-slot:cell(isValid)="row">
                            <span :class="row.item.isValid? 'text-success' : 'text-danger'">
                                {{ row.item.isValid? 'Thành công' : 'Thất bại' }}
                            </span>
                        </template>
                        <template v-slot:cell(actionType)="row">
                            {{ $store.getters.getActionName(row.item.actionType) }}
                        </template>
                        <template v-slot:cell(syncTargetId)="row">
                            <router-link :to="{ path: getTargetPath(row.value) }">
                                {{ row.value }}
                            </router-link>
                        </template>
                        <template v-slot:cell(errorMessage)="row">
                            <button size="sm" @click="showError(row.item, row.index, $event.target)" class="btn mr-2" style="box-shadow: none" v-if="row.value">
                                <i class="fa fa-exclamation-triangle" style="color: orangered" title="Xem chi tiết"></i>
                            </button>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button size="sm" @click="showDetail(row.item, row.index, $event.target)" class="mr-2" variant="info">
                                Xem
                            </b-button>
                        </template>
                    </b-grid>
                    <div class="text-center">
                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" ok-only>
            <json-viewer :data="infoModal.content"></json-viewer>
        </b-modal>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'MasterDataSyncLogDetail',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                },
                gridOptions: {
                    fields: [
                        { key: 'syncSourceId', label: 'Mã dữ liệu từ phần mềm gốc', sortable: true },
                        { key: 'syncTargetId', label: 'Mã dữ liệu sau đồng bộ', sortable: true },
                        { key: 'actionType', label: 'Loại hành vi', sortable: true },
                        { key: 'isValid', label: 'Trạng thái dữ liệu', sortable: true },
                        { key: 'errorMessage', label: 'Thông báo lỗi', sortable: false, tdClass: 'failure-status' }
                    ],
                    sortBy: 'isValid',
                },
                masterDataSync: {

                },
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                }
            }
        },
        computed: {
            logId() {
                return this.$route.params.logId;
            }
        },
        created() {
            this.loadLogDetail();
        },
        methods: {
            loadLogDetail() {
                var vm = this;
                return this.$services.get(`logging/master-data-sync-logs/${this.logId}`).done(data => {
                    if (!data) {
                        alert('Không tìm thấy bản ghi log này.');
                        this.back();
                        return;
                    }

                    vm.masterDataSync = data;
                });
            },
            showDetail(item, index, button) {
                this.$services.get(`logging/master-data-sync-logs/${this.logId}/data/${item.id}`).done(response => {
                    this.infoModal.title = `Thông tin dữ liệu được đồng bộ`;
                    this.infoModal.content = response;
                    this.$root.$emit('bv::show::modal', this.infoModal.id, button);
                });
            },
            showError(item, index, button) {
                this.infoModal.title = `Thông tin lỗi đồng bộ`;
                this.infoModal.content = item.errorMessage;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            back() {
                this.$router.push({ path: '.' });
            },
            getTargetPath(value) {
                var path;
                switch (this.masterDataSync.masterDataType) {
                    case 1: path = 'units'; break;
                    case 2: path = 'unit-types'; break;
                    case 3: path = 'asset-type-trees'; break;
                    case 4: path = 'asset-types'; break;
                    case 5: path = 'asset-sources'; break;
                    case 6: path = 'asset-usage-purposes'; break;
                    case 7: path = 'asset-usage-states'; break;
                    case 8: path = 'increasement-causes'; break;
                    case 9: path = 'decreasement-causes'; break;
                    case 10: path = 'countries'; break;
                    case 11: path = 'regions'; break;
                    case 12: path = 'users'; break;
                }

                if (path) {
                    return `/master-data/${path}/${value}`;
                } else {
                    return '#';
                }
            },
            searchData() {
                this.$refs.masterDataSyncLogDataTable.refresh();
            },
        },
        watch: {
            logId() {
                this.loadLogDetail();;
            }
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
